import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {CLStore} from 'common/src/redux/store';
import createChat from '../store/actions/createChat';
import createSupportChat from '../store/actions/createSupportChat';

// this must be called only after ALL agents have been registered, otherwise the chat may not have all the agents
export default function initializeCopilotChat(store: CLStore) {
  const isSupportOnlyMode = isFlagEnabled(FeatureFlagKey.EnableCopilotInSupportOnlyMode);
  store.dispatch(isSupportOnlyMode ? createSupportChat() : createChat());
}
